/* ============================================================
   product-extras.js
   ============================================================ */

(function () {
  'use strict';

  const WISHLIST_KEY = 'gts_wishlist';

  /* ── UTILITIES ── */
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function showToast(msg) {
    const toast = document.getElementById('wishlist-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    setTimeout(() => toast.classList.remove('is-visible'), 2800);
  }

  /* ── BACK BUTTON ── */
  const backBtn = document.getElementById('product-back-btn');
  if (backBtn) {
    backBtn.addEventListener('click', () => {
      const collectionUrl = backBtn.dataset.collectionUrl || '/collections/all';
      window.location.href = collectionUrl;
    });
  }

  /* ── WISHLIST ── */
  function initWishlist() {
    const btn = document.querySelector('.wishlist-btn');
    if (!btn) return;

    const productId = btn.dataset.productId;
    const productTitle = btn.dataset.productTitle;
    const productUrl = btn.dataset.productUrl;
    const productImage = btn.dataset.productImage;

    const list = getWishlist();
    const isWishlisted = list.some(item => item.id === productId);
    updateWishlistBtn(btn, isWishlisted);

    btn.addEventListener('click', () => {
      let list = getWishlist();
      const idx = list.findIndex(item => item.id === productId);

      if (idx === -1) {
        list.push({ id: productId, title: productTitle, url: productUrl, image: productImage });
        saveWishlist(list);
        updateWishlistBtn(btn, true);
        showToast('✓ Saved to wishlist');
      } else {
        list.splice(idx, 1);
        saveWishlist(list);
        updateWishlistBtn(btn, false);
        showToast('Removed from wishlist');
      }
    });
  }

  function updateWishlistBtn(btn, wishlisted) {
    btn.classList.toggle('is-wishlisted', wishlisted);
    btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    const label = btn.querySelector('.wishlist-label');
    if (label) label.textContent = wishlisted ? 'Saved' : 'Save';
    btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
  }

  /* ── SHARE DROPDOWN ── */
  function initShare() {
    const shareBtn = document.querySelector('.share-btn');
    if (!shareBtn) return;

    const productId = shareBtn.id.replace('share-toggle-', '');
    const dropdown = document.getElementById('share-dropdown-' + productId);
    if (!dropdown) return;

    shareBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = dropdown.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) {
        dropdown.classList.add('is-open');
        shareBtn.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', () => closeAllDropdowns());
    dropdown.addEventListener('click', (e) => e.stopPropagation());
  }

  function closeAllDropdowns() {
    document.querySelectorAll('.share-dropdown.is-open').forEach(d => {
      d.classList.remove('is-open');
    });
    document.querySelectorAll('.share-btn[aria-expanded="true"]').forEach(b => {
      b.setAttribute('aria-expanded', 'false');
    });
  }

  /* ── COPY LINK ── */
  function initCopyLink() {
    const copyBtn = document.querySelector('.copy-link-btn');
    if (!copyBtn) return;

    copyBtn.addEventListener('click', async () => {
      const url = copyBtn.dataset.url;
      const label = copyBtn.querySelector('.copy-label');
      try {
        await navigator.clipboard.writeText(url);
        if (label) label.textContent = 'Copied!';
        setTimeout(() => { if (label) label.textContent = 'Copy link'; }, 2000);
        closeAllDropdowns();
      } catch {
        const ta = document.createElement('textarea');
        ta.value = url;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        if (label) label.textContent = 'Copied!';
        setTimeout(() => { if (label) label.textContent = 'Copy link'; }, 2000);
        closeAllDropdowns();
      }
    });
  }

  /* ── AUTO COLOR SELECT ON SIZE CHANGE ── */
  function initAutoColorSelect() {
    var style = document.createElement('style');
    style.id = 'auto-color-select-style';
    document.head.appendChild(style);

    document.addEventListener('change', function(e) {
      if (!e.target.matches('input[name="Size-1"]')) return;

      var selectedSize = e.target.value;

      // Κρύψε πάντα το status όταν αλλάζει size
      style.textContent = '.variant-inventory-status, .price__badge-sold-out { visibility: hidden !important; }';

      // Βρες το τρέχον χρώμα
      var variantSelects = document.querySelector('variant-selects');
      var checkedColor = variantSelects ? variantSelects.querySelector('input[name="Color-2"]:checked') : null;
      var currentColor = checkedColor ? checkedColor.value : null;

      // Έλεγξε αν το τρέχον χρώμα είναι διαθέσιμο για το νέο size
      var currentColorAvailable = currentColor && (window.variantData || []).some(function(v) {
        return v.option1 === selectedSize && v.option2 === currentColor && window.variantInventory[v.id] > 0;
      });

      setTimeout(function() {
        variantSelects = document.querySelector('variant-selects');
        if (!variantSelects) {
          style.textContent = '';
          return;
        }

        if (currentColorAvailable) {
          // Το τρέχον χρώμα είναι διαθέσιμο — δεν αλλάζουμε χρώμα
          setTimeout(function() { style.textContent = ''; }, 500);
          return;
        }

        // Βρες το πρώτο διαθέσιμο χρώμα για το νέο size
        var availableVariant = (window.variantData || []).find(function(v) {
          return v.option1 === selectedSize && window.variantInventory[v.id] > 0;
        });

        if (!availableVariant) {
          style.textContent = '';
          return;
        }

        var colorInput = variantSelects.querySelector(
          'input[name="Color-2"][value="' + availableVariant.option2 + '"]'
        );
        if (colorInput) {
          colorInput.checked = true;
          colorInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        setTimeout(function() { style.textContent = ''; }, 500);
      }, 600);
    });
  }

  /* ── INIT ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initWishlist();
    initShare();
    initCopyLink();
    initAutoColorSelect();
  }

})();